<template>
  <div class="filter">
    <div class="row">
      <div class="small-3 columns">
        <div class="search-box">
          <label class="field-label">{{ $t('provider.list.filter.search') }}:</label>
          <div class="search">
            <div class="search-input-box">
              <input type="text" v-model="searchInput" ref="search" :disabled="loading"
                v-on:keypress.enter="search" v-on:blur="blurSearch" />
                <transition name="slide-left">
                  <i class="far fa-times-circle fa-lg" @click="clearSearch"
                    v-if="searchInput.length > 0"></i>
                </transition>
            </div>
            <button :class="{'button xsmall success':true, 'disabled':loading}"
              @click="search">
              <i class="fas fa-search fa-lg"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-show="isMobile ? isOpen : true">
        <div class="small-2 columns end">
          <div class="status">
            <label class="field-label">{{ $t('provider.list.filter.type') }}:</label>
            <select v-model="type" :disabled="loading">
              <option value="all">{{ $t('provider.list.filter.all') }}</option>
              <option value="tnc">{{ $t('provider.list.filter.tnc') }}</option>
              <option value="tcp">{{ $t('provider.list.filter.tcp') }}</option>
              <option value="psc">PSC</option>
            </select>
          </div>
        </div>

        <div class="small-2 columns end">
          <div class="status">
            <label class="field-label">{{ $t('provider.list.filter.status') }}:</label>
            <select v-model="statusTable" :disabled="loading">
              <option value="unarchived">{{ $t('provider.list.filter.allNonArchive') }}</option>
              <option value="activated">Active (On/Off Road)</option>
              <option value="active">On Road<!--{{ $t('provider.list.filter.active') }}--></option>
              <option value="inactive">Off Road<!--{{ $t('provider.list.filter.inactive') }}--></option>
              <option value="pending">Pending<!--{{ $t('provider.list.filter.pending') }}--></option>
              <option value="deactivated">{{ $t('provider.list.filter.deactivated') }}</option>
              <option value="archived">{{ $t('provider.list.filter.archived') }}</option>
            </select>
          </div>
        </div>

        <div class="small-2 columns end">
          <div class="status">
            <label class="field-label">Service:</label>
            <select v-model="serviceFilter" :disabled="loading">
              <option value="">All</option>
              <option value="PAX">PAX</option>
              <option value="DTD">DTD</option>
              <option value="PAX/DTD">PAX/DTD</option>
            </select>
          </div>
        </div>

        <!-- <div class="small-2 columns end">
          <div class="status">
            <label class="field-label">Service Type:</label>
            <select v-model="serviceType" :disabled="loading || services.serviceLoading">
              <optgroup v-for="(brand, index) in serviceTypes" :label="index" :key="`brand${index}`">
                <option v-for="(service, index2) in brand" :value="service.id" :key="`service${index2}`">{{service.name}}</option>
              </optgroup>
            </select>
          </div>
        </div> -->

        <div class="small-2 columns end small-offset-1">
          <div class="status last">
            <label class="field-label">&nbsp;</label>
            <div class="flex">
              <select v-model="status" :disabled="loading">
                <option value="activate">{{ $t('provider.list.filter.activate') }}</option>
                <option value="deactivate">{{ $t('provider.list.filter.deactivate') }}</option>
                <option value="archive">{{ $t('provider.list.filter.archive') }}</option>
              </select>
              <button :class="{'button small success':true, 'disabled':loading}" @click="updateStatus">Go</button>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="small-1 columns end">
        <div class="status last">
          <label class="field-label">&nbsp;</label>
          <button :class="{'button success block':true, 'disabled':loading}" @click="exportProv">EXPORT</button>
        </div>
      </div> -->

      <!-- <div class="small-1 columns end">
        <div class="status last">
          <label class="field-label">&nbsp;</label>
          <button :class="{'button block':true, 'disabled':loading}" @click="exportProvAll">EXPORT ALL</button>
        </div>
      </div> -->

    </div>
  </div>
</template>

<script>
/* global CONFIG */
import ApiProviderList from '@/modules/api/provider/list'
import ApiServices from '@/modules/api/services'
import CsvExport from 'csvexport'

let PNF = require('google-libphonenumber').PhoneNumberFormat
let phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()

const exporter = CsvExport.create({
  filename: 'export.csv',
  columns: [
    'Prov ID', 'Business Name', 'Type', 'Status', 'First Name', 'Last Name', 
    'Email', 'Mobile', 'Birthday', 'Address1', 'Address2', 'City', 'State', 'Country',
    'Zip', 'Language', 'Created', 'Last Update', 'Vehicle Type', 'Make', 
    'Model', 'Year', 'License Plate', 'Seat Capacity', 'VIN', 
    'Insurance Company Name', 'Insurance Policy #', 'Insurance Exp. Date', 
    'TCP Permit #', 'TCP Permit Exp. Date', 
    'City License #', 'City License Exp. Date', 
    'Airport Permit #', 'Airport Exp. Date', 
    'Driver\'s License #', 'Driver\'s License Exp. Date', 'Driving Record Exp. Date',
    'Safety Inspect', 'Last Login Timestamp', 'BG Check',
    'Shared', 'Opoli', 'Black', 'SUV', 'Private Shuttle'
  ]
})

const exporterAll = CsvExport.create({
  filename: 'export.csv',
  columns: [
    'Prov ID', 'Business Name', 'Type', 'Status', 'First Name', 'Last Name', 
    'Email', 'Mobile', 'Birthday', 'Address1', 'Address2', 'City', 'State', 'Country',
    'Zip', 'Language', 'Created', 'Last Update', 'Vehicle Type', 'Make', 
    'Model', 'Year', 'License Plate', 'Seat Capacity', 'VIN', 
    'Insurance Company Name', 'Insurance Policy #', 'Insurance Exp. Date', 
    'TCP Permit #', 'TCP Permit Exp. Date', 
    'City License #', 'City License Exp. Date', 
    'Airport Permit #', 'Airport Exp. Date', 
    'Driver\'s License #', 'Driver\'s License Exp. Date', 'Driving Record Exp. Date',
    'Safety Inspect', 'Last Login Timestamp', 'BG Check', 'Services'
  ]
})

export default {
  name: 'list-filter',
  props: ['isOpen', 'isMobile'],
  data () {
    return {
      searchInput: '',
      blurDelay: '',
      status: 'activate',
      selected: [],
      queedTables: [],
      serviceTypes: {}
    }
  },
  // components: {Picker},
  computed: {
    brands () { return this.$store.state.brands.list },
    type: {
      get: function () { return this.$store.state.provider.users.type },
      set: function (value) {
        this.$store.commit('provider/setUserType', value)
        this.refreshTable()
      }
    },
    statusTable: {
      get: function () { return this.$store.state.provider.users.status },
      set: function (value) {
        this.$store.commit('provider/setUserStatus', value)
        this.refreshTable()
      }
    },
    serviceFilter: {
      get: function () { return this.$store.state.provider.users.serviceFilter },
      set: function (value) {
        this.$store.commit('provider/setUserServiceFilter', value)
        this.refreshTable()
      }
    },
    serviceType: {
      get: function () { return this.$store.state.provider.users.serviceType },
      set: function (value) {
        this.$store.commit('provider/setUserServiceType', value)
        this.refreshTable()
      }
    },
    loading () { return this.$store.state.provider.users.isLoading },
    services () { return this.$store.state.services }
  },
  methods: {
    refreshTable () {
      let self = this
      if (self.loading) { return }

      self.queedTables = []
      if (self.type === 'all') {
        self.queedTables = ['tnc', 'tcp', 'psc']
        // self.$store.commit('provider/setUserIsLoading', {target: 'tnc', value: true})
        // self.$store.commit('provider/resetUsers', 'tnc')
        // self.$store.commit('provider/setUserCurrentPage', {target: 'tnc', value: 1})
        // ApiProviderList.getList2(self, self.createParams('tnc'), res => {
        //   self.$store.commit('provider/setUserIsLoading', {target: 'tnc', value: false})
        // })

        // self.$store.commit('provider/setUserIsLoading', {target: 'tcp', value: true})
        // self.$store.commit('provider/resetUsers', 'tcp')
        // self.$store.commit('provider/setUserCurrentPage', {target: 'tcp', value: 1})
        // ApiProviderList.getList2(self, self.createParams('tcp'), res => {
        //   self.$store.commit('provider/setUserIsLoading', {target: 'tcp', value: false})
        // })

        // self.$store.commit('provider/setUserIsLoading', {target: 'psc', value: true})
        // self.$store.commit('provider/resetUsers', 'psc')
        // self.$store.commit('provider/setUserCurrentPage', {target: 'psc', value: 1})
        // ApiProviderList.getList2(self, self.createParams('psc'), res => {
        //   self.$store.commit('provider/setUserIsLoading', {target: 'psc', value: false})
        // })
      } else {
        self.queedTables = [self.type]
        // self.$store.commit('provider/setUserIsLoading', {target: self.type, value: true})
        // self.$store.commit('provider/resetUsers', self.type)
        // self.$store.commit('provider/setUserCurrentPage', {target: self.type, value: 1})
        // ApiProviderList.getList2(self, self.createParams(self.type), res => {
        //   self.$store.commit('provider/setUserIsLoading', {target: self.type, value: false})
        // })
      }
      self.loadTables()
    },
    loadTables () {
      let self = this
      if (!self.queedTables.length) { return }

      self.$store.commit('provider/setUserIsLoading', {target: self.queedTables[0], value: true})
      self.$store.commit('provider/resetUsers', self.queedTables[0])
      self.$store.commit('provider/setUserCurrentPage', {target: self.queedTables[0], value: 1})
      ApiProviderList.getList2(self, self.createParams(self.queedTables[0]), res => {
        self.$store.commit('provider/setUserIsLoading', {target: self.queedTables[0], value: false})
        self.queedTables.shift()
        self.loadTables()
      })
    },
    createParams (target) {
      let params = {
        target: target,
        status: this.statusTable,
        type: target
      }
      if (this.serviceFilter === 'PAX') {
        params.isPax = 1
        params.isDTD = 0
      }
      if (this.serviceFilter === 'DTD') {
        params.isPax = 0
        params.isDTD = 1
      }
      if (this.serviceFilter === 'PAX/DTD') {
        params.isPax = 1
        params.isDTD = 1
      }
      return params
    },
    search () {
      this.$store.commit('provider/setUserSearch', this.searchInput)
      this.refreshTable()
    },
    blurSearch () {
      let self = this
      if (self.$store.state.provider.users.search === self.searchInput.trim()) {
        return
      }

      self.blurDelay = setTimeout(function () {
        self.search()
      }, 500)
    },
    clearSearch () {
      if (this.blurDelay) { clearTimeout(this.blurDelay) }
      if (this.loading) { return }

      this.searchInput = ''
      this.$store.commit('provider/setUserSearch', this.searchInput)
      this.refreshTable()
    },
    updateStatus () {
      let provList = this.$store.state.provider.users
      this.selected = [...provList.tnc.selectedUser, ...provList.tcp.selectedUser, ...provList.psc.selectedUser]
      if (provList.tnc.selectedUser.length) {
        this.$store.commit('provider/setUserIsLoading', {target: 'tnc', value: true})
      }
      if (provList.tcp.selectedUser.length) {
        this.$store.commit('provider/setUserIsLoading', {target: 'tcp', value: true})
      }
      if (provList.psc.selectedUser.length) {
        this.$store.commit('provider/setUserIsLoading', {target: 'psc', value: true})
      }
      this.processUpdateStatus(this.selected[0])
    },
    processUpdateStatus (id) {
      let self = this

      let provList = this.$store.state.provider.users
      if (self.status === 'archive') {
        ApiProviderList.archiveUser(self, id, function (res) {
          self.selected.shift()
          if (!self.selected.length) {
            if (provList.tnc.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', {target: 'tnc', value: false})
            }
            if (provList.tcp.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', {target: 'tcp', value: false})
            }
            if (provList.psc.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', {target: 'psc', value: false})
            }
            self.refreshTable()
          } else {
            self.processUpdateStatus(self.selected[0])
          }
        })
      } else {
        ApiProviderList.updateStatus(self, {
          id: id,
          isActive: self.status === 'activate'
        }, function (res) {
          self.selected.shift()
          if (!self.selected.length) {
            if (provList.tnc.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', {target: 'tnc', value: false})
            }
            if (provList.tcp.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', {target: 'tcp', value: false})
            }
            if (provList.psc.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', {target: 'psc', value: false})
            }
            self.refreshTable()
          } else {
            self.processUpdateStatus(self.selected[0])
          }
        })
      }
    },
    exportProv () {
      let self = this
      ApiProviderList.export(self, {}, function (res) {
        if (!res.error) {
          exporter.downloadCsv(res)
        }
      })
    },
    exportProvAll () {
      let self = this
      ApiProviderList.exportAll(self, {}, function (res) {
        if (!res.error) {
          exporterAll.downloadCsv(res)
        }
      })
    },
    getServices () {
      let self = this
      self.$store.commit('services/setServiceLoading', true)
      ApiServices.getAllService(self, r => {
        self.$store.commit('services/setServiceLoading', false)
        self.setServices()
      })
    },
    setServices () {
      let self = this
      self.services.list.forEach(service => {
        let brand = CONFIG.brands.find(x => x.id == service.brandId && service.enabled)
        if (!brand) return
        if (!self.serviceTypes[brand.name]) self.serviceTypes[brand.name] = []
        self.serviceTypes[brand.name].push(service)
      })
      self.$forceUpdate()
    }
  },
  mounted () {
    // if (!this.services.list.length) {
    //   this.getServices()
    // } else {
    //   this.setServices()
    // }
  }
}
</script>

<style lang="scss" scoped>
.filter{
  border-bottom:1px solid #bbb;
  background: #fcfcfc;
  margin-bottom: 10px;
  border-radius: 2px;

  .row{ max-width: 100%; }
}

.field-label{
  font-size: 13px;
  color: #999;
  line-height: 1;
  display: block;
  margin-bottom: 4px;
}

.search-box{
  display: inline-block;
  padding: 20px 0 20px 15px;
  position: relative;
  width: 100%;

  .error-msg{
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100% - 15px);
    padding: 2px 5px;
    font-size: 12px;
    text-align: center;
    margin-left: 15px;
    background: #ff6115;
    color: #fff;
    transform-origin: bottom center;
  }
}
.search{
  box-sizing: border-box;
  display: flex;
  width: 100%;

  .search-input-box{
    width: 100%;
    position: relative;

    input{
      display: inline-block;
      vertical-align: middle;
      margin-top: 0;
      border-radius: 5px 0 0 5px;
      padding-right: 30px;

      &.has-error{ border-color:#f33a27; }
    }
    i{
      position: absolute;
      top: 0;
      right: 5px;
      color: #d92626;
      cursor: pointer;
      line-height: 46px;
    }
  }
  button{
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    border-radius: 0 5px 5px 0;
    padding: 0 20px;
  }
}

.status{
  display: inline-block;
  padding: 20px 0 20px 15px;
  width: 100%;

  &.last{
    padding-right: 3px;
    padding-left: 3px;

    button{
      height: 46px;
    }
  }
}

select{
  padding: 10px;
  height: 46px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;

  &[disabled]{ background-color: #ebebe4; }
}

.flex{
  display: flex;

  select{
    flex-grow: 100;
  }
}

.slide-left-enter-active, .slide-left-leave-active { transition: all .3s ease; }
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(30px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {

  .filter {
    margin-top: 35px;
    padding-bottom: 15px;
  }
  .status {
    padding: 10px 0 0px 15px;
    &.last {
      padding-right: 0px;
      padding-left: 0px;
    }
  }
  .small-3 {
    width: 100%;
    .search-box {
      padding-right: 20px;
      padding-bottom: 0;
    }
  }
  .small-2 {
    width: 47%;
  }

  .small-offset-1 {
    float: none;
    padding-left: 15px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/ListFilter.vue